import React, { useContext, useState, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';

import { Modal, Col, Form, Row, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, Divider, Checkbox, Table } from 'antd';
import { roundedNumberFormatter } from '../../../components/formatters/numberFormatter';



import { FcKindle, FcDocument, FcBusinessman, FcInTransit, FcRedo, FcUndo, FcDeleteDatabase } from "react-icons/fc";
import { IoMdClose } from "react-icons/io";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { AiFillCloseSquare } from "react-icons/ai";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';


import DiscountModal from '../modals/discount';
import NetPriceModal from '../modals/netPrice';
import QuantityModal from '../modals/quantity';
import TotalDiscountModal from '../modals/totalDiscount';
import TotalPriceModal from '../modals/totalPrice';
import CustomerModal from '../modals/chooseCustomer';
import PayCashModal from '../modals/payCash';
import DetailsModel from '../modals/details';
import DeliveryModal from '../modals/chooseDelivery';
import UnitModal from '../modals/chooseUnit';

const Cart = (props) => {

    const { api, userData, settingData, selectedCompany, selectedYear, mainCurrency, secondaryCurrency,
        customerAccountData, deliveryData, userRole } = useContext(DataContext);

    const { tabData, setCart, setJournalVoucher } = useContext(PosCartContext);

    const userId = userData.id;
    const userName = userData.name;
    const createdBy = parseInt(userData.id);
    const companyId = selectedCompany.id;
    const yearId = selectedYear.id;

    const { toggleModal, setSelectedTab, selectedTab, subTotal, jvCost, jvProfit, totalDiscounts, setIsPrinting, isPrinting,
        discountPercentage, totalPrice, transactions, totalVatAmount, selectedCurrency, editedJv, refreshTableFunction,
        setSelectedPriceType, selectedPriceType } = props;

    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [idRow, setIdRow] = useState(true);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedProducts, setSelectedProducts] = useState([]);

    const [tabNames, setTabNames] = useState(['Tab1', 'Tab2', 'Tab3', 'Tab4']);




    const cart = tabData[selectedTab].cart;
    const journalVoucher = tabData[selectedTab].journalVoucher;


    const selectedProduct = useMemo(() => {
        return cart[selectedProducts[selectedProducts?.length-1]];
    }, [selectedProducts]);

    const selectedCustomer = useMemo(() => {
        return customerAccountData?.find(account => account.id === journalVoucher?.accountId);
    }, [journalVoucher?.accountId, cart, customerAccountData]);

    const selectedDelivery = useMemo(() => {
        return deliveryData?.find(account => account.id === journalVoucher?.deliveryId);
    }, [journalVoucher?.deliveryId]);

    const totalQuantity = useMemo(() => {
        return cart.reduce((sum, item) => sum + Number(item?.netQuantity || 0), 0);
    }, [cart]);


    useEffect(() => {
        if (editedJv) {
            setTabNames(prevTabs => [...prevTabs, 'ID: ' + editedJv?.id]);
            setSelectedTab(4);

            // set Cart
            const transformedData = editedJv?.cart?.map(({ product, ...rest }) => ({ ...rest, name: product?.name }));
            setCart(transformedData, 4);

            // set jv 
            const updatedJv = { ...journalVoucher };
            updatedJv.discountPercentage = editedJv?.discountPercentage;
            updatedJv.accountId = editedJv?.accountId;
            updatedJv.deliveryId = editedJv?.deliveryId;
            updatedJv.date = editedJv?.date;
            setJournalVoucher(updatedJv, 4);
        }
    }, [editedJv]);

    const [showDiscountModal, setShowDiscountModal] = useState(false);
    const [showNetPriceModal, setShowNetPriceModal] = useState(false);
    const [showQuantityModal, setShowQuantityModal] = useState(false);
    const [showTotalPriceModal, setShowTotalPriceModal] = useState(false);
    const [showTotalDiscountModal, setShowTotalDiscountModal] = useState(false);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showCashModal, setShowCashModal] = useState(false);
    const [showDeliveryModal, setShowDeliveryModal] = useState(false);
    const [showUnitModal, setShowUnitModal] = useState(false);


    const isUsingMainCurrency = selectedCurrency.id == mainCurrency.id ? true : false;
    const getRate = secondaryCurrency.rate;

    const ratedTotalPrice = isUsingMainCurrency ? (totalPrice / getRate) : (getRate * totalPrice);
    const ratedSymbol = isUsingMainCurrency ? secondaryCurrency.symbol : mainCurrency.symbol;


    const detailModal = () => {
        if (selectedProducts.length == 0) {
            toast.error('please select product')
            return;
        }
        if (selectedProducts.length > 1) {
            toast.error('please select one Product')
            return;
        }
        if (!showDetailModal) {
            setSelectedIndex(selectedProducts[0]);
        }
        setShowDetailModal(!showDetailModal);
    }

    const cashModal = (paymentType) => {

        if (!showCashModal) {
            if (paymentType == 'onAccount' && !journalVoucher.accountId) {
                toast.error('please select customer');
                return;
            }

            if (cart.length == 0) {
                toast.error('cart is empty')
                return;
            }

            // update jv paymentType
            const updatedJv = { ...journalVoucher };
            updatedJv.paymentType = paymentType;
            setJournalVoucher(updatedJv, selectedTab);
        }

        setShowCashModal(!showCashModal);
    }

    const totalPriceModal = () => {
        setShowTotalPriceModal(!showTotalPriceModal)
    }

    const unitModal = (record, index) => {
        if (record?.units.length == 0 && !showUnitModal) {
            toast.error('Item have no units');
            return
        }
        if (!showUnitModal) {
            setSelectedIndex(index)
            setIdRow(record)
        }
        setShowUnitModal(!showUnitModal)

    }

    const customerModal = () => {
        setShowCustomerModal(!showCustomerModal)
    }

    const deliveryModal = () => {
        setShowDeliveryModal(!showDeliveryModal)
    }

    const totalDiscountModal = () => {
        setShowTotalDiscountModal(!showTotalDiscountModal)
    }

    const quantityModal = (index) => {
        if (!showQuantityModal) {
            setSelectedIndex(index)
        }
        setShowQuantityModal(!showQuantityModal)
    }

    const discountModal = (index) => {
        if (!showDiscountModal) {
            setSelectedIndex(index)
        }
        setShowDiscountModal(!showDiscountModal)
    }


    const netPriceModal = (index) => {
        if (!showNetPriceModal) {
            setSelectedIndex(index)
        }
        setShowNetPriceModal(!showNetPriceModal)
    }


    const columns = useMemo(() => [
        { title: 'Product', dataIndex: 'name', width: '20%' },
        {
            title: 'Unit', dataIndex: 'unitName',
            render: (unitName, record) => (unitName + ' (' + record.unitQuantity + ')'),
            onCell: (record, index) => ({
                onClick: () => unitModal(record, index),
                style: { cursor: 'pointer' }
            }),
        },
        { title: 'Price', dataIndex: 'price', render: numberFormatter },
        {
            title: 'Dis', dataIndex: 'priceDiscountPercentage',
            onCell: (record, index) => ({
                onClick: () => userRole?.allowDiscountChange && discountModal(index),
                style: {
                    cursor: userRole?.allowDiscountChange ? 'pointer' : 'default',
                    color: 'inherit'
                },
            }),
            render: numberFormatter,
        },
        {
            title: 'Net', dataIndex: 'netPrice',
            onCell: (record, index) => ({
                onClick: () => userRole?.allowNetPriceChange && netPriceModal(index), style: {
                    cursor: userRole?.allowNetPriceChange ? 'pointer' : 'default',
                    color: 'inherit'
                },
            }),
            render: numberFormatter,
        },
        { title: 'Item', dataIndex: 'itemPrice', render: numberFormatter },
        {
            title: 'QTY', dataIndex: 'netQuantity',
            onCell: (record, index) => ({
                onClick: () => userRole?.allowQuantityChange && quantityModal(index, 'name'), style: {
                    cursor: userRole?.allowQuantityChange ? 'pointer' : 'default',
                    color: 'inherit'
                },
            }),
            render: numberFormatter,
        },
        { title: 'Total', dataIndex: 'totalPrice', render: numberFormatter, },
        Table.EXPAND_COLUMN,
    ], []);

    const changeToReturn = () => {
        let updatedJv = { ...journalVoucher };
        updatedJv.isDebit = !updatedJv.isDebit;
        setJournalVoucher(updatedJv, selectedTab);
    };

    const deleteItem = () => {
        let updatedCart = [...cart];

        if (settingData?.posItemReverse) {
            // Map reversed indices to original indices
            updatedCart = cart.filter((_, index) =>
                !selectedProducts
                    .map(selectedIndex => cart.length - 1 - selectedIndex)
                    .includes(index)
            );
        } else {
            updatedCart = cart.filter((_, index) =>
                !selectedProducts.includes(index)
            );
        }

        setCart(updatedCart, selectedTab);
        setSelectedProducts([]);
    };





    return (

        <div style={{ width: '50%', maxHeight: '100vh' }}>


            <div className="card" style={{ height: '7vh', marginLeft: -3 }}>
                <Row>

                    <Col md={1}>
                    </Col>


                    <Col md={3}>
                        <Dropdown style={{ width: '75px', margin: -9 }}>
                            <Dropdown.Toggle variant="secondary" style={{ height: '5vh', width: '120px', margin: 8, backgroundColor: '#94bbc3' }}>
                                {selectedPriceType}
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ width: '75px', minWidth: '120px', padding: 0, margin: 0, overflow: 'hidden' }}>

                                <Dropdown.Item
                                    onClick={() => setSelectedPriceType('By Price')}
                                    key={665}
                                    style={{ height: '55px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', border: '1px solid #ccc', }} >
                                    By Price
                                </Dropdown.Item>

                                {settingData?.defaultMultiPrices?.map((defaultPrice, index) => (
                                    <Dropdown.Item
                                        onClick={() => setSelectedPriceType(defaultPrice?.name)}
                                        key={index}
                                        style={{ height: '55px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', border: '1px solid #ccc', }} >
                                        {defaultPrice?.name}
                                    </Dropdown.Item>

                                ))}


                                {editedJv &&
                                    <Dropdown.Item
                                        onClick={() => setSelectedTab(4)}
                                        style={{ height: '55px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', border: '1px solid #ccc', }} >
                                        {tabNames[4]}
                                    </Dropdown.Item>
                                }

                            </Dropdown.Menu>
                        </Dropdown>


                    </Col>


                    <Col md={1}>
                        <FcDocument size={35} onClick={detailModal} style={{ cursor: 'pointer' }} />
                    </Col>

                    <Col md={2}>
                        <BiSolidTrash size={35} onClick={deleteItem} style={{ cursor: 'pointer', color: '#e6434f' }} />
                    </Col>

                    <Col md={3}>
                        <Dropdown style={{ width: '75px', margin: -9 }}>
                            <Dropdown.Toggle variant="secondary" style={{ height: '5vh', width: '120px', margin: 8 }}>
                                {tabNames[selectedTab]}
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ width: '75px', minWidth: '120px', padding: 0, margin: 0, overflow: 'hidden' }}                            >
                                {!editedJv &&
                                    <>
                                        <Dropdown.Item
                                            onClick={() => setSelectedTab(0)}
                                            style={{ height: '55px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', border: '1px solid #ccc', }} >
                                            {tabNames[0]}
                                        </Dropdown.Item>

                                        <Dropdown.Item
                                            onClick={() => setSelectedTab(1)}
                                            style={{ height: '55px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', border: '1px solid #ccc', }} >
                                            {tabNames[1]}
                                        </Dropdown.Item>

                                        <Dropdown.Item
                                            onClick={() => setSelectedTab(2)}
                                            style={{ height: '55px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', border: '1px solid #ccc', }} >
                                            {tabNames[2]}
                                        </Dropdown.Item>

                                        <Dropdown.Item
                                            onClick={() => setSelectedTab(3)}
                                            style={{ height: '55px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', border: '1px solid #ccc', }} >
                                            {tabNames[3]}
                                        </Dropdown.Item>
                                    </>
                                }

                                {editedJv &&
                                    <Dropdown.Item
                                        onClick={() => setSelectedTab(4)}
                                        style={{ height: '55px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', border: '1px solid #ccc', }} >
                                        {tabNames[4]}
                                    </Dropdown.Item>
                                }

                            </Dropdown.Menu>
                        </Dropdown>


                    </Col>

                    <Col md={2}>
                        <AiFillCloseSquare size={50} onClick={toggleModal} style={{ cursor: 'pointer', color: '#e6434f', marginTop: -5 }} />
                    </Col>
                </Row>
            </div>



            <div className="card " style={{ overflowY: 'auto', overflowX: 'hidden', height: '93vh', marginLeft: -3 }} >

                <Row>
                    <Table
                        className={'ant_table_cart custom-scrollbar'}
                        scroll={{ y: '55vh' }}
                        columns={columns}
                        dataSource={settingData?.posItemReverse ? [...tabData[selectedTab]?.cart].reverse() : tabData[selectedTab]?.cart}
                        pagination={false}
                        rowKey={(record, index) => index}
                        rowSelection={{
                            type: 'checkbox',
                            selectedRowKeys: selectedProducts, // Bind selected keys to state
                            onChange: (selectedRowKeys, selectedRows) => {
                                setSelectedProducts(selectedRowKeys);
                            },
                        }}
                        expandable={{
                            expandedRowRender: (record) => (
                                <p style={{ margin: 0, color: '#119FE2' }}>{record.details}</p>
                            ),
                            rowExpandable: (record) => !!record.details, // Only allow rows with details to be expandable
                        }}
                    />
                    <Divider />
                </Row>


                <Row style={{ marginTop: '-2%' }}>
                    {/* First Column with the 'ss' and 'dd' cards */}
                    <Col md={5}>


                        <Row className="mb-3">

                            <Col md={2}>
                            </Col>

                            <Col md={6}>
                                <Checkbox checked={isPrinting} onChange={(e) => setIsPrinting(e.target.checked)}>Print Invoice </Checkbox>
                            </Col>
                            <Col md={4}>
                                {journalVoucher?.isDebit ? (
                                    <div onClick={changeToReturn} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', margin: -5, width: '15%', height: '6vh' }}>
                                        <FcUndo size={30} />
                                        <span style={{ marginTop: '0px' }}>Return</span>
                                    </div>
                                ) : (
                                    <div onClick={changeToReturn} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', margin: -5, width: '15%', height: '6vh' }}>
                                        <FcRedo size={30} />
                                        <span style={{ marginTop: '0px' }}>Sale</span>
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <div onClick={customerModal} className='card' style={{ height: '120px', alignItems: 'center', padding: 15, cursor: 'pointer' }}>
                                    <FcBusinessman size={40} />
                                    <span style={{ fontSize: '13px' }}>{selectedCustomer?.english || 'Customer'}</span>
                                    <span style={{ fontSize: '13px' }}>{selectedCustomer?.phone}</span>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div onClick={deliveryModal} className='card' style={{ height: '120px', alignItems: 'center', padding: 15, cursor: 'pointer' }}>
                                    <FcInTransit size={40} />
                                    <span style={{ fontSize: '13px' }}>{selectedDelivery?.name || 'Delivery'}</span>
                                    <span style={{ fontSize: '13px' }}>{selectedDelivery?.phone}</span>
                                </div>
                            </Col>
                        </Row>

                        <Row>

                            {(settingData.showCostInCart && selectedProduct?.price) &&
                                <Col>
                                    SN: 1234#{selectedProduct?.price}#42365#785
                                </Col>
                            }
                        </Row>

                    </Col>

                    <Col md={1}>
                    </Col>
                    {/* Second Column with the Total, Discount, and Net Total sections */}
                    <Col md={6}>
                        <Row>
                            <Col md={1}></Col>
                            <Col md={7}>Total</Col>
                            <Col>{numberFormatter(subTotal)}</Col>
                        </Row>

                        <Row>
                            <Col md={1}></Col>
                            <Col md={7}>Total Quantity</Col>
                            <Col md={4}>{numberFormatter(totalQuantity)}</Col>
                        </Row>

                        <Row>
                            <Col md={1}></Col>
                            <Col md={7}>Discount %</Col>
                            <Col style={{
                                cursor: userRole?.allowDiscountChange ? 'pointer' : 'default',
                                color: 'inherit'
                            }}
                                onClick={userRole?.allowDiscountChange ? totalDiscountModal : undefined}>{numberFormatter(discountPercentage)}</Col>
                        </Row>

                        <Row className="mb-0">
                            <Col md={1}></Col>
                            <Col md={7}>
                                <span style={{ color: '#eb5355', fontWeight: 'bold' }}>Total VAT</span>
                            </Col>
                            <Col md={4}>
                                <span
                                    style={{ color: '#eb5355', cursor: 'pointer' }}>{numberFormatter(totalVatAmount) + ' ' + selectedCurrency.symbol}</span>
                            </Col>
                        </Row>

                        <Row className="mb-2">
                            <Col md={1}></Col>
                            <Col md={7}>
                                <span style={{ fontWeight: 'bold', color: '#018401' }}>Net Total</span>
                            </Col>
                            <Col md={4}>
                                <span
                                    style={{
                                        fontWeight: 'bold',
                                        cursor: userRole?.allowNetPriceChange ? 'pointer' : 'default',
                                        color: '#018401'
                                    }}
                                    onClick={userRole?.allowNetPriceChange ? totalPriceModal : undefined}
                                >
                                    {numberFormatter(totalPrice) + ' ' + selectedCurrency.symbol}
                                </span>
                            </Col>
                        </Row>


                        {settingData.showRateOnInvoiceChange &&
                            <Row style={{ marginTop: '-10px' }}>
                                <Col md={8}></Col>
                                <Col md={4}>
                                    <span style={{ fontWeight: 'bold', color: '#018401' }}>
                                        {numberFormatter(ratedTotalPrice, 2) + ratedSymbol}
                                    </span>
                                </Col>
                            </Row>
                        }


                        <Row>

                            {userRole.allowCredit &&

                                <Col md={6}>
                                    <button
                                        type="button"
                                        style={{ height: '80px', width: '100%', backgroundColor: '#eb5355', fontWeight: 'bold' }} className="btn btn-lg"
                                        onClick={() => cashModal('onAccount')} >
                                        Credit
                                    </button>
                                </Col>
                            }

                            {!userRole.allowCredit &&
                                <Col md={3}>

                                </Col>
                            }

                            <Col md={6}>
                                <button
                                    type="button"
                                    style={{ height: '80px', width: '100%', backgroundColor: '#a4c436', fontWeight: 'bold' }}
                                    className="btn btn-lg"
                                    onClick={() => cashModal('cash')} >
                                    Cash
                                </button>
                            </Col>
                        </Row>
                    </Col>
                </Row>


            </div>

            {showDiscountModal &&
                <DiscountModal
                    showModal={showDiscountModal}
                    toggleModal={discountModal}
                    selectedIndex={selectedIndex}
                    title={'Discount %'}
                    selectedTab={selectedTab}
                />
            }

            {showNetPriceModal &&
                <NetPriceModal
                    showModal={showNetPriceModal}
                    toggleModal={netPriceModal}
                    selectedIndex={selectedIndex}
                    title={'Net Price'}
                    selectedTab={selectedTab}
                />
            }

            {showQuantityModal &&
                <QuantityModal
                    showModal={showQuantityModal}
                    toggleModal={quantityModal}
                    selectedIndex={selectedIndex}
                    title={'Quantity'}
                    selectedTab={selectedTab}
                />
            }

            {showDetailModal &&
                <DetailsModel
                    showModal={showDetailModal}
                    toggleModal={detailModal}
                    title={'Add details'}
                    selectedIndex={selectedIndex}
                    selectedTab={selectedTab}
                />
            }

            {showUnitModal &&
                <UnitModal
                    showModal={showUnitModal}
                    toggleModal={unitModal}
                    selectedIndex={selectedIndex}
                    idRow={idRow}
                    title={'Choose Unit'}
                    selectedTab={selectedTab}
                    selectedCurrency={selectedCurrency}
                />
            }

            {showTotalDiscountModal &&
                <TotalDiscountModal
                    showModal={showTotalDiscountModal}
                    toggleModal={totalDiscountModal}
                    idRow={idRow}
                    title={'Final Discount'}
                    selectedTab={selectedTab}
                    subTotal={subTotal}
                />
            }

            {showTotalPriceModal &&
                <TotalPriceModal
                    showModal={showTotalPriceModal}
                    toggleModal={totalPriceModal}
                    idRow={idRow}
                    title={'Final Price'}
                    selectedTab={selectedTab}
                    subTotal={subTotal}
                    totalVatAmount={totalVatAmount}
                />
            }

            {showCustomerModal &&
                <CustomerModal
                    showModal={showCustomerModal}
                    toggleModal={customerModal}
                    title={'Choose Customer'}
                    selectedTab={selectedTab}
                />
            }


            {showDeliveryModal &&
                <DeliveryModal
                    showModal={showDeliveryModal}
                    toggleModal={deliveryModal}
                    title={'Choose Delivery'}
                    selectedTab={selectedTab}
                />
            }

            {showCashModal &&
                < PayCashModal
                    showModal={showCashModal}
                    toggleModal={cashModal}
                    closePos={toggleModal}
                    title={'Pay Cash'}
                    totalPrice={totalPrice}
                    selectedTab={selectedTab}
                    transactions={transactions}
                    selectedCurrency={selectedCurrency}
                    isPrinting={isPrinting}
                    jvCost={jvCost}
                    jvProfit={jvProfit}
                    totalDiscounts={totalDiscounts}
                    jvId={editedJv?.id}
                    refreshTableFunction={refreshTableFunction}
                    ratedTotalPrice={ratedTotalPrice}
                    ratedSymbol={ratedSymbol}
                    totalVatAmount={totalVatAmount}

                />
            }

        </div>

    )
}


export default Cart;